module.exports = __webpack_public_path__ + "img/shop-owner.16917cdd.png";